/**
 * Patients Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import {store} from "../../store";
// States
const state = {
    drugs: [],
    drug: {}
};

// Getters
const getters = {
    drugs: state => {
        return state.drugs
    },

    drug: state => {
        return state.drug
    }
};

// Actions
const actions = {
    getDrugs(context, payload) {
        function successCallback(response) {
            context.commit('getDrugsHandler', { drugs: response.data.medicaments });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medicament.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getDrug(context, payload) {
        function successCallback(response) {
            context.commit('getDrugHandler', { drug: response.data.medicament });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medicament.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createDrug(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'drug', params: { drug: response.data.medicament.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medicament.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateDrug(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'drug' });
            router.push({ name: 'drug', params: { patient: response.data.medicament.slug } });
            // router.push({ name: 'patients' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medicament.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteDrug(context, payload) {
        function successCallback(response) {
            context.commit('deleteDrugHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Medicament.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getDrugsHandler(state, { drugs }) {
        // Update patients state
        state.drugs = drugs;
    },

    getDrugHandler(state, { drug }) {
        // Update patient state
        state.drug = drug;
    },

    deleteDrugHandler(state, { index, successMessage }) {
        // let i = state.patients.findIndex(patient => patient.slug === index);

        // if (~i) {
        //     state.patients.splice(i, 1);

            router.push({ name: 'drugs' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        // }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}